// Admin token storage: extracted from URL hash on first visit, then moved
// to sessionStorage so refreshes/other tabs in the same window stay
// authenticated. Hash is cleared from the URL so the token doesn't sit in
// browser history.

const STORAGE_KEY = 'tubr.admin-token';

export function consumeAdminTokenFromHash(): void {
  const hash = window.location.hash;
  if (!hash) return;
  const m = /^#token=([A-Za-z0-9]+)/.exec(hash);
  if (!m) return;
  sessionStorage.setItem(STORAGE_KEY, m[1]!);
  window.history.replaceState({}, '', window.location.pathname);
}

export function getAdminToken(): string | null {
  return sessionStorage.getItem(STORAGE_KEY);
}

export function setAdminToken(token: string): void {
  sessionStorage.setItem(STORAGE_KEY, token);
}

export function clearAdminToken(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}

export async function adminFetch(path: string, init?: RequestInit): Promise<Response> {
  const token = getAdminToken();
  const headers = new Headers(init?.headers);
  if (token) headers.set('x-admin-token', token);
  return fetch(path, { ...init, headers });
}
